/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SimilarProfileReviews } from './';
import {
    SimilarProfileReviewsFromJSON,
    SimilarProfileReviewsFromJSONTyped,
    SimilarProfileReviewsToJSON,
} from './';

/**
 * 
 * @export
 * @interface SimilarProfile
 */
export interface SimilarProfile {
    /**
     * 
     * @type {string}
     * @memberof SimilarProfile
     */
    profileId: string;
    /**
     * 
     * @type {string}
     * @memberof SimilarProfile
     */
    firstname: string;
    /**
     * 
     * @type {string}
     * @memberof SimilarProfile
     */
    lastname: string;
    /**
     * 
     * @type {string}
     * @memberof SimilarProfile
     */
    headline: string;
    /**
     * 
     * @type {string}
     * @memberof SimilarProfile
     */
    canonicalUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SimilarProfile
     */
    avatarUrl?: string;
    /**
     * 
     * @type {SimilarProfileReviews}
     * @memberof SimilarProfile
     */
    reviews?: SimilarProfileReviews;
    /**
     * 
     * @type {number}
     * @memberof SimilarProfile
     */
    numberOfRecommendations?: number;
}

/**
 * Check if a given object implements the SimilarProfile interface.
 */
export function instanceOfSimilarProfile(value: object): value is SimilarProfile {
    if (!('profileId' in value) || value['profileId'] === undefined) return false;
    if (!('firstname' in value) || value['firstname'] === undefined) return false;
    if (!('lastname' in value) || value['lastname'] === undefined) return false;
    if (!('headline' in value) || value['headline'] === undefined) return false;
    if (!('canonicalUrl' in value) || value['canonicalUrl'] === undefined) return false;
    return true;
}

export function SimilarProfileFromJSON(json: any): SimilarProfile {
    return SimilarProfileFromJSONTyped(json, false);
}

export function SimilarProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimilarProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'profileId': json['profileId'],
        'firstname': json['firstname'],
        'lastname': json['lastname'],
        'headline': json['headline'],
        'canonicalUrl': json['canonicalUrl'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'reviews': json['reviews'] == null ? undefined : SimilarProfileReviewsFromJSON(json['reviews']),
        'numberOfRecommendations': json['numberOfRecommendations'] == null ? undefined : json['numberOfRecommendations'],
    };
}

export function SimilarProfileToJSON(value?: SimilarProfile | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profileId': value['profileId'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'headline': value['headline'],
        'canonicalUrl': value['canonicalUrl'],
        'avatarUrl': value['avatarUrl'],
        'reviews': SimilarProfileReviewsToJSON(value['reviews']),
        'numberOfRecommendations': value['numberOfRecommendations'],
    };
}

